<template>
  <el-container @keyup.enter.native="submitForm('loginForm')">
    <el-header height="100px" class="zy-header">
      <img class="logo" src="../assets/img/new/login_logo.png" alt />
    </el-header>
    <el-main class="zy-main">
      <div class="login-box">
        <div class="welcome-des">
          欢迎您，
          <br />
          登录智云药店系统
        </div>
        <el-tabs v-model="loginType">
          <el-tab-pane label="密码登录" name="password">
            <el-form :rules="rules" :model="loginForm" status-icon ref="loginForm">
              <el-form-item prop="userName">
                <el-input
                  class="zy-input mobile"
                  v-model.trim="loginForm.userName"
                  placeholder="手机号或登录名"
                ></el-input>
              </el-form-item>
              <el-form-item prop="password" class="code">
                <el-input type="password" v-model.trim="loginForm.password" placeholder="密码"></el-input>
              </el-form-item>

              <div v-if="loginForm.password && loginForm.userName" class="loginBtn" @click="submitForm('loginForm')">
                <span>登 录</span>
              </div>
              <div v-else class="loginBtn disloginBtn">
                <span>登 录</span>
              </div>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="验证码登录" name="test">
            <el-form :rules="rules" :model="loginForm" status-icon ref="loginForm">
              <el-form-item prop="mobile">
                <el-input class="zy-input mobile" v-model.trim="loginForm.mobile" placeholder="手机号"></el-input>
              </el-form-item>
              <el-form-item prop="verifyCode" class="code">
                <el-col>
                  <el-form-item prop="verifyCode">
                    <el-input class="zy-input" v-model="loginForm.verifyCode" placeholder="验证码"></el-input>
                  </el-form-item>
                  <el-button
                    class="text-btn"
                    v-show="!codeSend"
                    @click="sendCode('formName')"
                    type="text"
                    :disabled="disabledCode"
                  >
                    {{ getCodeFre > 0 ? '重新获取' : '获取验证码' }}
                  </el-button>
                  <span class="time" v-show="codeSend">{{ time }}s</span>
                </el-col>
              </el-form-item>
              <el-form-item class="voice-code" v-if="voiceCodeBox">
                <p>
                  收不到验证码？立即使用
                  <span class="tip" @click="sendVoiceVerifyCode">语音验证码</span>
                </p>
              </el-form-item>

              <div v-if="!disabledSubmit" class="loginBtn" @click="submitForm('loginForm')">
                <span>登 录</span>
              </div>
              <div v-else class="loginBtn disloginBtn">
                <span>登 录</span>
              </div>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-main>
    <div class="footer">
      杭州康明信息技术有限公司 浙ICP备2021004431号-18 增值电信业务经营许可证：浙B2-20210258
      <br />
      Copyright©2021 All Rights Reserved Hangzhou Kang Ming Information Technology Co., Ltd All Rights Reserved
    </div>
  </el-container>
</template>

<script>
import { Tabs, Header, Main, Form, FormItem, Input, Col, Button, Container, TabPane } from 'element-ui';
import Vue from 'vue';
import Fetch from '../api';
Vue.use(Header);
Vue.use(Main);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Col);
Vue.use(Button);
Vue.use(Container);
Vue.use(Tabs);
Vue.use(TabPane);

const loginBC = new BroadcastChannel('login_channel');
export default {
  name: 'Login',
  data() {
    return {
      disabledSubmit: true,
      disabledCode: true,
      codeSend: false,
      time: 60,
      timer: null,
      loginForm: {
        mobile: '',
        verifyCode: ''
      },
      rules: {
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { min: 11, max: 11, message: '手机号长度为11个数字', trigger: 'blur' },
          { message: '手机号格式不正确', pattern: /^1[1234567890]\d{9}$/, trigger: 'blur' }
        ]
      },
      voiceCodeBox: false, // 语音验证码框
      getCodeFre: 0, // 获取验证码次数
      loginType: 'password'
    };
  },

  created() {
    Util.removeCookie('userInfo');
    loginBC.onmessage = function () {
      location.reload();
    };
    Fetch.getUserAndStoreInfo({}, { ishideError: true }).then(res => {
      if (res.userId) {
        this.$router.replace('/');
      }
    });
  },
  watch: {
    loginForm: {
      handler(val) {
        const last = val.mobile.length - 1;
        if (val.mobile && !Util.isNumber(val.mobile[last] * 1)) {
          this.loginForm.mobile = val.mobile.slice(0, last);
        }
        if (val.mobile.length > 11) {
          this.loginForm.mobile = val.mobile.slice(0, 11);
        }

        this.$refs.loginForm.validate(valid => {
          if (valid) {
            this.disabledCode = false;
            this.disabledSubmit = false;
          } else {
            this.disabledCode = true;
            this.disabledSubmit = true;
          }
        });

        this.disabledSubmit = !val.verifyCode;
      },
      deep: true
    }
  },
  methods: {
    initData() {
      this.disabledSubmit = true;
      this.disabledCode = true;
      this.codeSend = false;
      this.time = 60;
      this.timer = null;
      this.loginForm = {
        mobile: '',
        verifyCode: ''
      };
    },
    submitForm(formName) {
      const { loginForm, loginType } = this;
      const params = {};
      if (loginType === 'test') {
        const { mobile, verifyCode } = loginForm;
        if (mobile == '') {
          this.$message.error('请输入手机号');
          return;
        }
        if (verifyCode == '') {
          this.$message.error('请输入验证码');
          return;
        }
        Object.assign(params, { mobile, verifyCode });
      } else {
        const { userName, password } = loginForm;
        if (userName == '') {
          this.$message.error('登录名不能为空');
          return;
        }
        if (password == '') {
          this.$message.error('密码不能为空');
          return;
        }
        Object.assign(params, { userName, password });
      }
      Fetch[loginType === 'test' ? 'login' : 'userLogin'](params)
        .then(data => {
          // 登陆成功后直接跳转页面 无需做任何操作 直接跳转
          if (data) {
            loginBC.postMessage('loginSuccess');
            this.$router.push(sessionStorage.getItem('router_from') || '/').catch(e => {});
          }
        })
        .catch(e => {});
    },
    sendCode(formName) {
      Util.submitOnce(this.sendVerifyCode);
    },
    sendVerifyCode() {
      let self = this;
      Fetch.sendVerifyCode(self.loginForm.mobile)
        .then(() => {
          self.$message({
            message: '短信验证码已发送至您的手机，请查收'
          });
          self.codeSend = true;
          // 获取验证码次数递增
          self.getCodeFre++;
          this.timer = setInterval(() => {
            self.time = self.time - 1;
            // 30s后,显示语音验证码
            if (self.time == 30) {
              self.voiceCodeBox = true;
            }
            if (self.time < 0) {
              self.codeSend = false;
              self.time = 60;
              // 重新获取的时候，语音验证码关闭
              self.voiceCodeBox = false;
              clearInterval(self.timer);
            }
          }, 1000);
        })
        .catch(e => {
          // 解决Unhandled promise rejection;undefined;
          console.log(e);
        });
    },
    // 发送语音验证码
    sendVoiceVerifyCode() {
      Util.submitOnce(this._sendVoiceVerifyCode, this);
    },
    // 发送语音验证码
    _sendVoiceVerifyCode() {
      let self = this;
      Fetch.sendVoiceVerifyCode(self.loginForm.mobile).then(() => {
        self.$message({
          message: '已发送，请注意来电'
        });
        self.voiceCodeBox = false;
      });
    },
    validateMobile(value) {
      if (!/^1(3|4|5|7|8)\d{9}$/.test(value)) {
        return false;
      } else {
        return true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/style/element-variables';
.welcome-des {
  width: 192px;
  height: 72px;
  font-size: 24px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #000000;
  margin-bottom: 24px;
  line-height: 36px;
}
.footer {
  width: 100%;
  text-align: center;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #bfbfbf;
  margin-top: 33px;
  line-height: 17px;
}
.zy-header {
  height: 100px;
  line-height: 100px;
  text-align: left;
}
.zy-header .logo {
  vertical-align: middle;
  width: 240px;
  margin-left: 20px;
}
.login-box {
  width: 380px;
  height: 420px;
  background: #fff;
  float: right;
  margin-top: 100px;
  margin-right: 100px;
  padding: 48px 50px;
}

.zy-main {
  background: #f1f7f7 url('../assets/img/new/login_bg.jpg') 50% 50% / auto calc(100vh - 218px) no-repeat;
  text-align: left;
  height: calc(100vh - 218px);
  padding: 0;
}

.loginBtn {
  border-radius: 4px;
  width: 280px;
  height: 48px;
  font-size: 14px;
  color: #ffffff;
  margin-top: 20px;
  background: #1e8dff;
  cursor: pointer;
  text-align: center;
  line-height: 48px;
}
.disloginBtn {
  color: rgba(255, 255, 255, 0.5);
  cursor: not-allowed;
}
.login-btn {
  /* background:#32c795; */
  border-radius: 4px;
  width: 280px;
  height: 48px;
  font-size: 14px;
  color: #ffffff;
  margin-top: 20px;
}

.login-box .mobile .el-form-item__content {
  width: 280px !important;
}
.login-box .el-input__inner {
  height: 48px !important;
}
.text-btn,
.time {
  line-height: 48px;
  padding: 0;
  position: absolute;
  top: 0;
  right: 14px;
  width: 70px;
  text-align: right;
  color: #1e8dff;
}
.time {
  cursor: default;
}
.login-text {
  display: block;
  font-size: 18px;
  color: #333333;
  line-height: 18px;
  margin-bottom: 24px;
}
.code {
  margin-bottom: 0;
}
.voice-code {
  margin: 8px 0 0;
  font-size: 12px;
  color: #707070;
  p {
    height: 15px;
    line-height: 15px;
  }
  .tip {
    color: #1e8dff;
    cursor: pointer;
  }
}
/deep/ .el-tabs__active-bar {
  background: $--color-primary;
}
/deep/ .el-tabs__item {
  &:hover,
  &.is-active {
    color: $--color-primary;
  }
}
</style>
